import React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  TextField,
  TextInput,
  SimpleForm,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  Filter,
  Show,
  SimpleShowLayout,
  ArrayField,
  SingleFieldList,
  ChipField,
} from 'react-admin'
import { ArchivalToolbar } from '../components/ArchivalToolbar'
import {
  ArchivedSelect,
  CourseField,
  CourseIdSelect,
  CourseSelect,
} from '../components/selects'
import { useCourseIds } from '../utils/useCourseIds'

const ListBase = (props) => {
  const course_ids = useCourseIds()

  return (
    <List
      filter={course_ids ? { course_id: course_ids } : null}
      sort={{ field: 'name', order: 'ASC' }}
      filters={<SurveyFilter />}
      perPage={25}
      {...props}
    >
      <SurveyList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <SurveyShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <SurveyForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <SurveyForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const SurveyFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <CourseIdSelect alwaysOn />
    <ArchivedSelect />
  </Filter>
)

const SurveyList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField label="Survey Name" source="name" />
    <CourseField />
  </Datagrid>
)

const SurveyShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField label="Survey Name" fullWidth source="name" />
    <CourseField />

    <ArrayField label="Fields" source="fields">
      <SingleFieldList>
        <ChipField style={{ margin: '16px 10px 16px 0' }} source="name" />
      </SingleFieldList>
    </ArrayField>
  </SimpleShowLayout>
)

const SurveyForm = (props) => (
  <SimpleForm toolbar={<ArchivalToolbar />} warnWhenUnsavedChanges {...props}>
    <TextInput label="Survey Name" fullWidth source="name" />

    <CourseSelect />

    <ArrayInput source="fields">
      <SimpleFormIterator>
        <TextInput fullWidth label="Name" source="name" />

        <SelectInput
          fullWidth
          source="type"
          label="Field Type"
          defaultValue="text"
          choices={[
            { id: 'text', name: 'Text' },
            { id: 'number', name: 'Number' },
            { id: 'date', name: 'Date' },
          ]}
        />
      </SimpleFormIterator>
    </ArrayInput>
  </SimpleForm>
)
